import React from 'react'
import PropTypes from 'prop-types'
import TenantsTableRow from './tenants-table-row'

const tableHeadings = ['Tenant Name', 'Created']

const TenantsTable = ({ tenants, onUpdated }) => (
  <table className='table table-bordered'>
    <thead>
      <tr>
        {tableHeadings.map(heading => (
          <th className='sorting' key={heading}>
            {heading} <i className='fa fa-sort' />
          </th>
        ))}
        <th className='width-fifteen' />
      </tr>
    </thead>
    <tbody>
      {tenants.map(tenant => (
        <TenantsTableRow key={tenant.id} {...tenant} onUpdated={onUpdated} />
      ))}
    </tbody>
  </table>
)

TenantsTable.propTypes = {
  tenants: PropTypes.array,
  onUpdated: PropTypes.func
}

TenantsTable.displayName = 'TenantsTable'

export default TenantsTable



// WEBPACK FOOTER //
// ./src/pages/admin/tenants/tenants-table.js